import { ActionTypes } from 'modules/jobManager/ducks/actionTypes';
import { JOBS_TABLE_COLUMNS, JobAction, JobTableSortState } from 'modules/jobManager/types';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

export const initialJobTableSortState: JobTableSortState = {
  sortBy: JOBS_TABLE_COLUMNS.JOB_ID,
  sortDirection: SORT_DIRECTIONS.DESCENDING,
};

export const jobTableSortReducer = (state = initialJobTableSortState, action?: JobAction) => {
  switch (action?.type) {
    case ActionTypes.SET_TABLE_SORT_BY: {
      return {
        ...state,
        sortBy: action?.payload ?? state.sortBy,
      };
    }

    case ActionTypes.SET_TABLE_SORT_DIRECTION: {
      return {
        ...state,
        sortDirection: action?.payload ?? state.sortDirection,
      };
    }

    default:
      return state;
  }
};
